<div class="relative" *transloco="let t">
	<button class="absolute right-2 top-2 z-10" mat-icon-button (click)="onCancel()" [attr.aria-label]="t('commonActions.close')">
		<mat-icon>close</mat-icon>
	</button>
	<h2 mat-dialog-title cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">
		{{ t('permissionStages.changeGroupnameDialog.title').replace('%%', data.groupName) }}
	</h2>

	<form [formGroup]="changeGroupName" (ngSubmit)="onSubmit()">
		<mat-dialog-content>
			@if (mandatoryChange) {
				<p class="mb-4 font-bold whitespace-pre-wrap">
					{{ t('permissionStages.changeGroupnameDialog.mandatoryDescription') }}
				</p>
			}
			<p class="mb-4 whitespace-pre-wrap">
				{{ t('permissionStages.changeGroupnameDialog.enterNewName') }}
			</p>

			<mat-form-field class="w-full">
				<mat-label>{{ t('permissionStages.groupName') }}</mat-label>
				<input matInput formControlName="groupName" />
				@if (changeGroupName.get('groupName')?.hasError('required')) {
					<mat-error>{{ t('common.requiredField') }}</mat-error>
				}
			</mat-form-field>
		</mat-dialog-content>

		<mat-dialog-actions align="end">
			<button mat-flat-button color="primary" type="submit" [disabled]="!changeGroupName.valid">
				{{ t('commonActions.save') }}
			</button>
		</mat-dialog-actions>
	</form>
</div>
